import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // In production, this would send to your backend
    console.log('Contact form:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  const contactMethods = [
    {
      icon: '📧',
      title: 'Email Support',
      description: 'support@addisonelectronique.com',
      response: 'Response within 24 hours'
    },
    {
      icon: '💬',
      title: 'Live Chat',
      description: 'Available for Pro & Enterprise',
      response: 'Response within minutes'
    },
    {
      icon: '🐦',
      title: 'Twitter/X',
      description: '@addisonelectron',
      response: 'Public responses only'
    }
  ];

  return (
    <div className="fade-in" style={{ maxWidth: '900px', margin: '0 auto' }}>
      {/* Hero */}
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <h1 style={{ fontSize: '36px', fontWeight: '800', marginBottom: '16px' }}>
          Get In Touch
        </h1>
        <p style={{ fontSize: '16px', color: 'var(--text-muted)' }}>
          Have a question or need help? We're here for you.
        </p>
      </div>

      {/* Contact Methods */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '20px',
        marginBottom: '50px'
      }}>
        {contactMethods.map((method, index) => (
          <div key={index} className="card" style={{ padding: '24px', textAlign: 'center' }}>
            <div style={{ fontSize: '32px', marginBottom: '12px' }}>{method.icon}</div>
            <h3 style={{ fontSize: '16px', fontWeight: '700', marginBottom: '8px' }}>
              {method.title}
            </h3>
            <p style={{ fontSize: '14px', color: 'var(--text)', marginBottom: '4px' }}>
              {method.description}
            </p>
            <p style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
              {method.response}
            </p>
          </div>
        ))}
      </div>

      {/* Contact Form */}
      <div className="card" style={{ padding: '40px' }}>
        <h2 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '24px' }}>
          Send Us a Message
        </h2>

        {submitted ? (
          <div style={{
            background: 'rgba(16, 185, 129, 0.1)',
            border: '1px solid #10B981',
            color: '#10B981',
            padding: '20px',
            borderRadius: '8px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '10px' }}>✅</div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>
              Message Sent!
            </h3>
            <p>We'll get back to you as soon as possible.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: 'var(--text-muted)' }}>
                  Your Name
                </label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    background: 'var(--darker)',
                    border: '1px solid var(--border)',
                    borderRadius: '8px',
                    color: 'var(--text)'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: 'var(--text-muted)' }}>
                  Your Email
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    background: 'var(--darker)',
                    border: '1px solid var(--border)',
                    borderRadius: '8px',
                    color: 'var(--text)'
                  }}
                />
              </div>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: 'var(--text-muted)' }}>
                Subject
              </label>
              <select
                value={formData.subject}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'var(--darker)',
                  border: '1px solid var(--border)',
                  borderRadius: '8px',
                  color: 'var(--text)'
                }}
              >
                <option value="">Select a topic...</option>
                <option value="general">General Inquiry</option>
                <option value="support">Technical Support</option>
                <option value="billing">Billing Question</option>
                <option value="feature">Feature Request</option>
                <option value="bug">Bug Report</option>
                <option value="security">Security Issue</option>
              </select>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: 'var(--text-muted)' }}>
                Message
              </label>
              <textarea
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                rows={6}
                required
                placeholder="How can we help you?"
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'var(--darker)',
                  border: '1px solid var(--border)',
                  borderRadius: '8px',
                  color: 'var(--text)',
                  resize: 'vertical'
                }}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%', padding: '14px' }}
            >
              📤 Send Message
            </button>
          </form>
        )}
      </div>

      {/* FAQ Link */}
      <div style={{ textAlign: 'center', marginTop: '30px' }}>
        <p style={{ color: 'var(--text-muted)' }}>
          Looking for quick answers?{' '}
          <a href="/help" style={{ color: '#DC2626', textDecoration: 'none' }}>
            Check our FAQ
          </a>
        </p>
      </div>
    </div>
  );
};

export default Contact;

